<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Currency</mat-label>
    <mat-select id="pricing-currency" formControlName="currency">
      @for (option of currencyNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
